import { render, staticRenderFns } from "./TotalUser.vue?vue&type=template&id=205ec420&scoped=true&"
import script from "./TotalUser.vue?vue&type=script&lang=js&"
export * from "./TotalUser.vue?vue&type=script&lang=js&"
import style0 from "./TotalUser.vue?vue&type=style&index=0&id=205ec420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205ec420",
  null
  
)

export default component.exports